module.exports = __webpack_public_path__ + "static/scale-model-of-bourbon-city-cruisers-in-louisville-kentucky-a762876de6daf565da44bec410ed8d30.png";